// eslint-disable-next-line import/prefer-default-export
export const TRACK_TYPES = {
  TRACK_EVENT: 'trackEvent',
  TRACK_LINK: 'trackLink',
  TRACK_SEARCH: 'trackSiteSearch',
  TRACK_VIEW: 'trackPageView',
  TRACK_ECOMMERCE_ORDER: 'trackEcommerceOrder',
  TRACK_ECOMMERCE_CART_UPDATE: 'trackEcommerceCartUpdate',
}
